import { render, staticRenderFns } from "./ArchiveClientDetailPopUp.vue?vue&type=template&id=8b6dcdaa&scoped=true&"
import script from "./ArchiveClientDetailPopUp.vue?vue&type=script&lang=js&"
export * from "./ArchiveClientDetailPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveClientDetailPopUp.vue?vue&type=style&index=0&id=8b6dcdaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6dcdaa",
  null
  
)

export default component.exports